module.exports = __webpack_public_path__ + "static/media/my-maps.7a0d5327.svg";